const sleep = (m = 150) => new Promise((r) => setTimeout(r, m));

export {sleep};
